import { Modal } from "antd";
import { RootState } from "app.store";
import { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { setGlobalMessage } from "states/global-value/global-value.slice";

export function GlobalMessageModal() {
  const message = useSelector(
    (state: RootState) => state.globalValue.globalMessage,
    shallowEqual
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (message) {
      Modal.warning({
        title: "Thông báo",
        content: message,
        afterClose: () => {
          dispatch(setGlobalMessage(undefined));
        },
      });
    }
  }, [message]);
  return null;
}
